export function LearnerExpiredPage(): JSX.Element {
  return (
    <div className="max-w-md mx-auto p-12 text-center space-y-3">
      <h1 className="text-2xl font-semibold">This training link has expired</h1>
      <p className="text-sm text-ink-muted">
        Please contact the organization that invited you to request a fresh enrollment link.
      </p>
    </div>
  );
}
